import "./FormCard.css";

interface FormCardProps {
    children: React.ReactNode;
}

interface FormCardBodyProps {
    children: React.ReactNode;
}

interface FormCardFooterProps {
    children: React.ReactNode;
}

const FormCardBody = ({ children }: FormCardBodyProps) => (
    <div className="form-card-body">{children}</div>
);

const FormCardFooter = ({ children }: FormCardFooterProps) => (
    <>{children}</>
);

const FormCard = ({ children }: FormCardProps) => {
    return (
        <div className="form-card">{children}</div>
    );
};

FormCard.Body = FormCardBody;
FormCard.Footer = FormCardFooter;

export default FormCard;
